module.exports = __webpack_public_path__ + "static/media/component-10.bbaf777d.svg";